import { useCallback } from "react";

import type { S3Object } from "@/lib/gql/__generated__/graphql";

import type { HotelSettingsHotelInfoFormModelOnSetViewModelType } from "../..";
import type { HotelSettingsHotelInfoFormModel } from "../../../../type";

type Props = {
	viewModel: HotelSettingsHotelInfoFormModel["ViewModel"];
	onSetViewModel: HotelSettingsHotelInfoFormModelOnSetViewModelType;
};

export type HotelSettingsHotelInfoFormModelLogoImageMethodsType = {
	logoMethods: {
		onSetMainKeyVisual: (value: S3Object | null) => void;
		isEdited: boolean;
		errorMessage: string | undefined;
	};
};

export const useHotelInfoLogo = ({ viewModel, onSetViewModel }: Props) => {
	const onSetMainKeyVisual = useCallback(
		(value: S3Object | null) => {
			const s3Object = value;

			const newMainKeyVisual = {
				key: {
					isEdited: true,
					value: s3Object?.key ?? "",
				},
				bucket: {
					isEdited: true,
					value: s3Object?.bucket ?? "",
				},
				mimeType: {
					isEdited: true,
					value: s3Object?.mimeType ?? "",
				},
				fileName: {
					isEdited: true,
					value: s3Object?.fileName ?? "",
				},
				region: {
					isEdited: true,
					value: s3Object?.region ?? "",
				},
			};

			onSetViewModel([
				{
					key: "logoImage",
					value: newMainKeyVisual,
				},
			]);
		},
		[onSetViewModel],
	);

	const isEdited = Boolean(
		viewModel.logoImage?.bucket?.isEdited ||
			viewModel.logoImage?.key?.isEdited ||
			viewModel.logoImage?.region?.isEdited ||
			viewModel.logoImage?.mimeType?.isEdited ||
			viewModel.logoImage?.fileName?.isEdited,
	);

	const errorMessage =
		viewModel.logoImage?.bucket?.error ||
		viewModel.logoImage?.key?.error ||
		viewModel.logoImage?.region?.error ||
		viewModel.logoImage?.mimeType?.error ||
		viewModel.logoImage?.fileName?.error;

	return {
		logoMethods: {
			onSetMainKeyVisual,
			isEdited,
			errorMessage,
		},
	};
};
